import React from 'react'

export const ArrowOutwardIcon = ({ width = 24, height = 24 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='currentColor'
    width={width}
    height={height}
  >
    <path d='M6.294 17.644 5.25 16.6l9.84-9.85H6.144v-1.5h11.5v11.5h-1.5V7.804l-9.85 9.84Z' />
  </svg>
)

export const UpIcon = ({ width = 22, height = 13 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 22 13'
    fill='currentColor'
    width={width}
    height={height}
  >
    <path d='M11 2L11.7071 1.29289L11 0.585786L10.2929 1.29289L11 2ZM21.7071 11.2929L11.7071 1.29289L10.2929 2.70711L20.2929 12.7071L21.7071 11.2929ZM10.2929 1.29289L0.292893 11.2929L1.70711 12.7071L11.7071 2.70711L10.2929 1.29289Z' />
  </svg>
)
